import HelpIcon from '@material-ui/icons/Help';
import { IconButton, Tooltip, useMediaQuery, useTheme, makeStyles } from '@material-ui/core';
import Gleap from 'gleap';

import { iconColor } from 'src/data/colors';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: iconColor,

    [theme.breakpoints.down('sm')]: {
      color: 'white',
    },
  },
}));

export const HelpWidget = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  return (
    <Tooltip title="Help">
      <IconButton
        color="inherit"
        aria-haspopup="true"
        data-testid="help-button"
        onClick={() => {
          Gleap.open();
        }}
        size={isSmallScreen ? 'small' : 'medium'}
      >
        <HelpIcon className={classes.icon} />
      </IconButton>
    </Tooltip>
  );
};
